import { QRCodeSVG } from "qrcode.react";
import { useEffect } from "react";

// Eigenstaendige, einmalige Fullscreen-Seite fuer den "Tag der offenen Tuer" (40-Zoll-TV im
// Studio, Querformat). Bewusst KOMPLETT losgeloest vom bestehenden TV-Modul (/tv,
// routers_tv.py) - keine Datenbank, keine Verwaltung, keine Einstellungen, alle Texte fest im
// Code. Nur fuer diesen einen Tag gedacht; danach kann die Route/Datei einfach wieder entfernt
// werden, ohne irgendetwas anderes im System zu beruehren.
//
// WICHTIG (Korrektur ggue. der ersten Fassung): Kein fester 1920x1080-Container mehr, der per
// JS-Skalierung in den Viewport gepasst wird - das erzeugte auf echten TV-Browsern schwarze
// Rand-/Leerflaechen, sobald der tatsaechliche Viewport nicht exakt im 16:9-Verhaeltnis war. Der
// Fernseher-Browser liefert bereits einen 16:9-Viewport, daher fuellt die Seite jetzt direkt
// 100vw/100vh, und alle Groessen sind in vh/vw statt fixer px angegeben - das skaliert sauber mit
// dem tatsaechlichen Fenster mit, ganz ohne Messen/Transformieren per JS.

const NEON = "#c6ff33";

export default function TV2Page() {
  // Nur waehrend diese eine Seite gemountet ist Scrollen unterbinden - bewusst per JS am Element
  // statt in einer globalen CSS-Datei, damit /tv2 dafuer keine gemeinsam genutzte Datei anfassen
  // und keine andere Seite im System (inkl. /tv) davon beeinflusst werden muss.
  useEffect(() => {
    const vorher = {
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow,
      bodyMargin: document.body.style.margin,
    };
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.margin = "0";
    return () => {
      document.documentElement.style.overflow = vorher.htmlOverflow;
      document.body.style.overflow = vorher.bodyOverflow;
      document.body.style.margin = vorher.bodyMargin;
    };
  }, []);

  return (
    <div style={S.aussen}>
      <div style={S.hintergrundbild} />
      <div style={S.abdunklung} />

      <div style={S.inhalt}>
        <div style={S.oben}>
          {/* Links: Tag der offenen Tuer */}
          <div style={{ ...S.spalte, flexBasis: "42%" }}>
            <img src="/logo.png" alt="ComeFit" style={S.logo} />
            <div style={S.zeileTagDer}>TAG DER</div>
            <div style={S.pinselWrapper}>
              <div style={S.pinselstrich} />
              <div style={S.zeileOffenTuer}>OFFENEN TÜR</div>
            </div>
            <div style={S.datum}>20.09. | 10–18 Uhr</div>
            <div style={S.unterzeile}>Willkommen beim Tag der offenen Tür!</div>
          </div>

          {/* Mitte: QR-Code */}
          <div style={{ ...S.spalte, flexBasis: "25%", alignItems: "center", textAlign: "center" }}>
            <div style={S.scannenTitel}>JETZT SCANNEN</div>
            <div style={S.scannenUntertitel}>und direkt online anmelden</div>
            <div style={S.qrRahmen}>
              {/* size=340 bleibt fuer eine ausreichend feine interne Aufloesung (Anzahl Module),
                  die TATSAECHLICHE Darstellungsgroesse kommt ueber style/width+height in vh - sonst
                  bleibt der QR-Code als einziges Element der Seite in festen Pixeln und wirkt auf
                  einem TV mit kleinerem tatsaechlichem Viewport (z.B. 40 Zoll) im Verhaeltnis zu
                  allem anderen viel zu gross (Nutzer-Meldung 2026-09-14). */}
              <QRCodeSVG value="https://app.comefit.de/mitglied-werden" size={340} level="M" fgColor="#0a0a0a" bgColor="#ffffff" style={S.qrCode} />
            </div>
            <div style={S.scannenFooter}>Schnell. Einfach. Direkt online.</div>
          </div>

          {/* Rechts: Sonderaktionen */}
          <div style={{ ...S.spalte, flexBasis: "33%" }}>
            <div style={S.eyebrow}>NUR AN DIESEM TAG</div>
            <div style={S.sektionTitel}>SONDERAKTIONEN</div>
            <AktionsZeile titel="6 MONATE" zusatz="+ 1 MONAT GRATIS" />
            <AktionsZeile titel="12 MONATE" zusatz="+ 2 MONATE GRATIS" />
            <AktionsZeile titel="WECHSELAKTION" zusatz="3 MONATE GRATIS" klein="danach 6 Monate Bindung" />
            <AktionsZeile titel="PARTNER-RABATT" zusatz="5 €" />
          </div>
        </div>

        {/* Unten: Gewinnspiel, ueber die volle Breite, ca. 30% der Bildschirmhoehe */}
        <div style={S.gewinnspielBalken}>
          <div style={S.gewinnspielKopf}>
            <div style={S.gewinnspielTitel}>GROSSES GEWINNSPIEL</div>
            <div style={S.verlosungZeile}>
              VERLOSUNG UM <span style={S.uhrzeitGross}>17:00 UHR</span>
            </div>
          </div>
          <div style={S.gewinnKacheln}>
            <GewinnKachel medaille="🥇" platz="1. PLATZ" dauer="12 MONATE" />
            <GewinnKachel medaille="🥈" platz="2. PLATZ" dauer="6 MONATE" />
            <GewinnKachel medaille="🥉" platz="3. PLATZ" dauer="3 MONATE" />
          </div>
          <div style={S.mitmachenZeile}>MITMACHEN &amp; GEWINNEN!</div>
        </div>
      </div>
    </div>
  );
}

function AktionsZeile({ titel, zusatz, klein }) {
  return (
    <div style={S.aktionsZeile}>
      <div style={S.aktionsTitel}>{titel}</div>
      <div style={S.aktionsZusatz}>{zusatz}</div>
      {klein && <div style={S.aktionsKlein}>{klein}</div>}
    </div>
  );
}

function GewinnKachel({ medaille, platz, dauer }) {
  return (
    <div style={S.gewinnKachel}>
      <div style={S.gewinnMedaille}>{medaille}</div>
      <div style={S.gewinnPlatz}>{platz}</div>
      <div style={S.gewinnDauer}>{dauer}</div>
      <div style={S.gewinnLabel}>Mitgliedschaft</div>
    </div>
  );
}

// Alle Groessen bewusst in vh/vw statt px - dadurch fuellt die Seite bei jeder tatsaechlichen
// Fenstergroesse (solange 16:9) exakt den Bildschirm, ohne JS-Messung/Skalierung und ohne
// Leerflaechen. 1vh entspricht bei 1080px Hoehe 10.8px, 1vw bei 1920px Breite 19.2px - als
// Anhaltspunkt beim Nachjustieren.
const S = {
  aussen: {
    position: "fixed", inset: 0, width: "100vw", height: "100vh",
    background: "#000", overflow: "hidden",
    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
  },
  hintergrundbild: {
    position: "absolute", inset: 0,
    backgroundImage: "url(/sonderaktion_hero.png)", backgroundSize: "cover", backgroundPosition: "center",
  },
  abdunklung: {
    position: "absolute", inset: 0,
    background: "linear-gradient(180deg, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.93) 55%, rgba(0,0,0,0.97) 100%)",
  },
  inhalt: {
    position: "relative", zIndex: 1, width: "100%", height: "100%",
    display: "flex", flexDirection: "column",
    padding: "3vh 3vw 2.5vh",
    boxSizing: "border-box",
  },
  oben: {
    display: "flex", flex: 1, minHeight: 0, gap: "2vw",
  },
  spalte: {
    display: "flex", flexDirection: "column", minWidth: 0, justifyContent: "center",
  },

  // ---- Links ----
  logo: { height: "6vh", objectFit: "contain", marginBottom: "3vh", alignSelf: "flex-start" },
  zeileTagDer: { color: "#fff", fontSize: "6.8vh", fontWeight: 800, letterSpacing: "0.1vh", lineHeight: 1.05 },
  pinselWrapper: { position: "relative", display: "inline-block", marginTop: "0.5vh", marginBottom: "2.6vh", alignSelf: "flex-start" },
  pinselstrich: {
    position: "absolute", left: "-1.2vw", right: "-1.4vw", top: "16%", bottom: "8%",
    background: NEON, borderRadius: "6px 40px 10px 46px / 30px 6px 40px 6px",
    transform: "rotate(-1.2deg)",
  },
  zeileOffenTuer: {
    position: "relative", color: "#0a0a0a", fontSize: "9.2vh", fontWeight: 900, letterSpacing: "0.05vh",
    lineHeight: 1.02, padding: "1vh 1.2vw", whiteSpace: "nowrap",
  },
  datum: { color: NEON, fontSize: "4.4vh", fontWeight: 700, marginBottom: "1.6vh" },
  unterzeile: { color: "#e6e6e6", fontSize: "3.1vh", fontWeight: 500 },

  // ---- Mitte ----
  scannenTitel: { color: NEON, fontSize: "5.2vh", fontWeight: 900, letterSpacing: "0.1vh", marginBottom: "0.8vh" },
  scannenUntertitel: { color: "#e6e6e6", fontSize: "2.4vh", fontWeight: 500, marginBottom: "2.6vh" },
  qrRahmen: { background: "#fff", padding: "2vh", borderRadius: "2vh", boxShadow: "0 0 0 0.6vh rgba(198,255,51,0.35)" },
  qrCode: { width: "24vh", height: "24vh", display: "block" },
  scannenFooter: { color: "#bdbdbd", fontSize: "2.1vh", fontWeight: 500, marginTop: "2.6vh" },

  // ---- Rechts ----
  eyebrow: { color: NEON, fontSize: "2.6vh", fontWeight: 800, letterSpacing: "0.3vh", marginBottom: "0.4vh" },
  sektionTitel: { color: "#fff", fontSize: "5.4vh", fontWeight: 900, letterSpacing: "0.05vh", marginBottom: "2.2vh" },
  aktionsZeile: {
    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(198,255,51,0.35)",
    borderRadius: "1.4vh", padding: "1.6vh 1.6vw", marginBottom: "1.4vh",
  },
  aktionsTitel: { color: "#fff", fontSize: "3.2vh", fontWeight: 800, letterSpacing: "0.05vh" },
  aktionsZusatz: { color: NEON, fontSize: "2.9vh", fontWeight: 800, marginTop: "0.2vh" },
  aktionsKlein: { color: "#a9a9a9", fontSize: "1.7vh", fontWeight: 500, marginTop: "0.4vh" },

  // ---- Gewinnspiel (~30% der Bildschirmhoehe, deutlich groesser als vorher) ----
  gewinnspielBalken: {
    marginTop: "2vh", height: "30vh", flexShrink: 0,
    background: "rgba(198,255,51,0.08)", border: "0.25vh solid #c6ff33",
    borderRadius: "2vh", padding: "2vh 3vw",
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between",
  },
  gewinnspielKopf: { textAlign: "center" },
  gewinnspielTitel: { color: NEON, fontSize: "4vh", fontWeight: 900, letterSpacing: "0.3vh" },
  verlosungZeile: { color: "#fff", fontSize: "3.2vh", fontWeight: 700, marginTop: "0.6vh" },
  uhrzeitGross: { color: NEON, fontSize: "5.8vh", fontWeight: 900 },
  gewinnKacheln: { display: "flex", gap: "2.4vw" },
  gewinnKachel: {
    background: "rgba(0,0,0,0.55)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "1.8vh",
    padding: "1.8vh 3vw", textAlign: "center", minWidth: "18vw",
  },
  gewinnMedaille: { fontSize: "5vh", lineHeight: 1 },
  gewinnPlatz: { color: "#fff", fontSize: "2.3vh", fontWeight: 700, letterSpacing: "0.1vh", marginTop: "0.4vh" },
  gewinnDauer: { color: NEON, fontSize: "4.6vh", fontWeight: 900, marginTop: "0.3vh" },
  gewinnLabel: { color: "#bdbdbd", fontSize: "1.9vh", fontWeight: 500 },
  mitmachenZeile: { color: "#fff", fontSize: "3vh", fontWeight: 800, letterSpacing: "0.1vh" },
};
